<template>
  <v-container class="list-clients-page" fluid>
    <div class="list-clients-header">
      <h1 class="list-clients-header__title">{{ $route.meta.title }}</h1>
      <div class="list-clients-header__actions">
        <v-switch
          v-if="roleName === 'admin'"
          v-model="withoutSubscribers"
          class="list-clients-header__switch mt-0 pt-0"
          color="primary"
          hide-details
          label="Только с абонентами"
          @change="showDuplicate()"
        />
        <v-menu bottom left offset-y transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="$checkPermission('export_csv_client')"
              color="primary"
              outlined
              rounded
              class="list-clients-header__btn text-none"
              dark
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>mdi-download-outline</v-icon>
              Скачать отчёт
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="downloadReport()">
              <v-list-item-title>Полный отчёт</v-list-item-title>
            </v-list-item>
            <v-list-item @click="downloadReportPage()">
              <v-list-item-title>Отчёт на странице</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          v-if="$checkPermission('create_client')"
          color="primary"
          class="list-clients-header__btn text-none"
          dark
          rounded
          to="/client/new"
        >
          <v-icon left>mdi-account-plus-outline</v-icon>
          Новый клиент
        </v-btn>
      </div>
    </div>

    <v-card class="list-clients-block mt-3" flat outlined>
      <div class="list-clients-filters">
        <div class="list-clients-filters__title">
          <v-icon left small>mdi-filter-variant</v-icon>
          Фильтры
        </div>
        <div class="list-clients-filters__row">
          <v-text-field
            v-model="serchPhone"
            placeholder="Номер телефона"
            outlined
            dense
            hide-details
            clearable
            class="list-clients-filters__field"
            prepend-inner-icon="mdi-phone-outline"
            @keyup.enter="filterClients()"
          />
          <v-text-field
            v-model="serchAddress"
            placeholder="Адрес"
            outlined
            dense
            hide-details
            clearable
            class="list-clients-filters__field"
            prepend-inner-icon="mdi-map-marker-outline"
            @keyup.enter="filterClients()"
          />
          <v-text-field
            v-model="serchCode"
            placeholder="Код ключа"
            outlined
            dense
            hide-details
            clearable
            class="list-clients-filters__field"
            prepend-inner-icon="mdi-key-outline"
            @keyup.enter="filterClients()"
          />
          <v-btn color="primary" class="text-none" dark rounded @click.prevent="filterClients">
            <v-icon left>mdi-magnify</v-icon>
            Поиск
          </v-btn>
        </div>
      </div>
      <v-divider class="my-0" />
      <v-data-table
        class="table"
        :options.sync="options"
        :headers="headers"
        :items="clients"
        disable-sort
        :server-items-length="totalClients"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-options': [5, 10, 20, 50, 100, 500],
        }"
      >
              <template v-slot:item.telephone="{ item }">
                <span>{{ formatPhoneNumber(item.telephone) }}</span>
                <v-tooltip v-if="item.without_doorphone" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      color="orange"
                      text-color="white"
                      class="ml-2"
                    >
                      Без домофона
                    </v-chip>
                  </template>
                  <span>Клиент только с шлагбаумами (без домофона)</span>
                </v-tooltip>
              </template>
              <template v-slot:item.doorphones="{ item }">
                  <ul v-for="doorphone in getDoorphones(item)" v-bind:key="doorphone.id">
                    <router-link class="routerLink" :to="`/doorphones/${doorphone.id}`">
                      {{ getDoorphoneAddress(doorphone) }}
                    </router-link>
                  </ul>
              </template>
              <template v-slot:item.barriers="{ item }">
                <template v-if="item.without_doorphone">
                  <ul v-for="barrier in getBarriersForWithoutDoorphone(item)" v-bind:key="barrier.id">
                    <router-link class="routerLink" :to="`/barrier/${barrier.id}`">
                      {{ barrier.address ? `ID ${barrier.id} — ${barrier.address}` : barrier.id || `Шлагбаум ID ${barrier.id}` }}
                    </router-link>
                  </ul>
                  <span v-if="!getBarriersForWithoutDoorphone(item).length" class="grey--text">—</span>
                </template>
                <template v-else>
                  <ul v-for="barrier in getBarriers(item)" v-bind:key="barrier.id">
                    <router-link class="routerLink" :to="`/barrier/${barrier.id}`">
                      {{ barrier.address }}
                    </router-link>
                  </ul>
                </template>
              </template>
              <template v-slot:item.StatusClient="{ item }">
                <ul v-for="apartment_sip_settings in getStatusClient(item)" v-bind:key="apartment_sip_settings.id">
                  {{ getStatusPaid(apartment_sip_settings.paid) }}
                </ul>
              </template>
              <template v-slot:item.status="{ item }">
                <ul v-for="status in getStatuses(item)" v-bind:key="status.id">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        text
                        tile
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="btn__icon pa-0"
                        width="18"
                        height="18"
                        style="cursor: default;"
                      >
                        <v-icon
                          :color="(status === 'A') ? 'green' : (status === 'B') ? 'yellow' : 'red'"
                          x-small
                        >
                          mdi-checkbox-blank-circle
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ getStatusesClients(status) }}</span>
                  </v-tooltip>
                </ul>
              </template>
              <template v-slot:item.Code="{ item }">
                  <ul v-for="keys in getKeys(item)" v-bind:key="keys.id">
                    {{ keys.code }}
                  </ul>
              </template>
              <template v-slot:item.actions="{ item }">
                <template v-if="$canRoute('DetailClientGeneralInfoClient')">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        text
                        tile
                        small
                        v-bind="attrs"
                        v-on="on"
                        class="btn__icon pa-0"
                        width="18"
                        height="18"
                        :to="`/client/${item.id}`"
                      >
                        <v-icon>mdi-information-slab-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Информация</span>
                  </v-tooltip>
                </template>
                <template v-else>Информация</template>
              </template>
            </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import cp1251Encode from '@/mixins/cp1251Encode';

export default {
  name: 'Clients',
  mixins: [ruDateFormatMixin, cp1251Encode],
  data () {
    return {
      dialog: {},
      isCreated: false,
      options: {
        page: 1,
        itemsPerPage: 20,
      },
      filters: {},
      serchPhone: '',
      serchAddress: '',
      serchCode: '',
      withoutSubscribers: false,
      include: ['abonents.doorphones', 'abonents.keys', 'abonents.apartmentSipSettings'],
      totalClients: 0,
      headers: [
        { text: 'Телефон', value: 'telephone', sortable: false },
        { text: 'Домофон', value: 'doorphones' },
        { text: 'Шлагбаум', value: 'barriers' },
        { text: 'Код ключа', value: 'Code', sortable: false },
        { text: 'Статус аккаунта', value: 'StatusClient', sortable: false },
        { text: 'Статус', value: 'status' },
        { text: '', value: 'actions', sortable: false, align: 'center' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      clients: 'Client/clients',
      roleName: 'roleName',
    }),
  },
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.getClients();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      loadClients: 'Client/loadClients',
      deleteClient: 'Client/deleteClient',
      exportCsv: 'Client/exportCsv',
    }),
    formatPhoneNumber (phoneNumber) {
      phoneNumber = phoneNumber.toString();
      const digits = phoneNumber.replace(/\D/g, '');
      return `+${digits.slice(0, 1)} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
    },
    filterClients () {
      this.options.page = 1;
      // const phoneNumberToSend = this.serchPhone.replace(/\D/g, '');
      this.filters = {
        ...(this.serchPhone && { telephone_v2: this.serchPhone }),
        ...(this.serchAddress && { address: this.serchAddress }),
        ...(this.serchCode && { code: this.serchCode }),
      };
      if (this.withoutSubscribers) {
        this.filters.has_abonents = 'true';
      } else {
        delete this.filters.has_abonents;
      }
      this.getClients();
    },
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.type === 'G') {
        address += ' (калитка)';
      }
      if (doorphone.entrance > 0) {
        address = `${doorphone.address}, п.${doorphone.entrance}, кв.${doorphone.apartment}`;
        if (doorphone.type === 'A') {
          address += ' (доп.вход)';
        }
      }
      return address;
    },
    getClients () {
      this.loadClients({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        filters: this.filters,
        include: this.include,
        sort: this.sort = ['-id'],
      })
        .then(({ meta }) => {
          this.totalClients = meta.total;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке клиентов');
        });
    },
    downloadReport () {
      this.exportCsv()
        .then((response) => {
          const url = URL.createObjectURL(new Blob([response], {
            type: 'application/csv',
          }));
          const link = document.createElement('a');
          link.href = url;
          link.download = 'ListClient.csv';
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          this.$flash_warning('Ошибка при скачивании отчёта');
        });
    },
    downloadReportPage () {
      const lines = [];
      this.clients.forEach((item) => {
        const createdAt = this.ruDateFormat(item.created_at, true);

        if (item.abonents && item.abonents.length > 0) {
          item.abonents.forEach((abonent) => {
            const address = abonent.address || '';
            const statusPaid = this.getStatusPaid(abonent?.apartment_sip_settings?.[0]?.paid) || '';
            const statusesClients = this.getStatusesClients(abonent?.status) || '';

            const line = [
              item.telephone, address,
              statusPaid, statusesClients, createdAt,
            ].join(';');
            lines.push(line);
          });
        } else {
          const line = [
            item.telephone, '',
            '', '',
            createdAt,
          ].join(';');
          lines.push(line);
        }
      });

      const link = document.createElement('a');
      link.href = `data:text/csv;charset=CP1251,${this.encodeCP1251(lines.join('\n'))}`;
      link.download = 'list-clients.csv';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getStatusPaid (paid) {
      switch (paid) {
        case true: return ' Pro - версия';
        case false: return ' Lite - версия';
      }
    },
    getStatusesClients (status) {
      switch (status) {
        case 'A': return ' Активен ';
        case 'B': return ' Заблокирован ';
        case 'D': return ' Удален ';
      }
    },
    getDoorphones (item) {
      const doorphones = [];
      item.abonents.forEach(abonent => {
        if (abonent.doorphones) {
          abonent.doorphones.forEach(doorphone => {
            doorphone.apartment = abonent.apartment;
            doorphones.push(doorphone);
          });
        }
      });
      return doorphones;
    },
    getBarriers (item) {
      const barriersSet = new Set();
      if (!item.abonents) return [];
      item.abonents.forEach(abonent => {
        if (abonent.doorphones) {
          abonent.doorphones.forEach(doorphone => {
            if (doorphone.barriers) {
              doorphone.barriers.forEach(barrier => {
                barriersSet.add(barrier);
              });
            }
          });
        }
      });
      return Array.from(barriersSet);
    },
    /** Шлагбаумы для клиента «без домофона»: из item.barriers или по item.barrier_ids */
    getBarriersForWithoutDoorphone (item) {
      if (item.barriers && Array.isArray(item.barriers) && item.barriers.length > 0) {
        return item.barriers;
      }
      if (item.barrier_ids && Array.isArray(item.barrier_ids)) {
        return item.barrier_ids.map(id => ({ id, address: `Шлагбаум ID ${id}` }));
      }
      return [];
    },
    showDuplicate () {
      this.options.page = 1;
      this.filterClients();
    },
    getKeys (item) {
      const keys = [];
      item.abonents.forEach(abonent => {
        if (abonent.keys) {
          abonent.keys.forEach(doorphone => {
            keys.push(doorphone);
          });
        }
      });
      return keys;
    },
    getStatusClient (item) {
      const apartmentSipSettings = [];
      item.abonents.forEach(abonent => {
        if (abonent.apartment_sip_settings) {
          abonent.apartment_sip_settings.forEach(doorphone => {
            apartmentSipSettings.push(doorphone);
          });
        }
      });
      return apartmentSipSettings;
    },
    getStatuses (item) {
      const status = [];
      item.abonents.forEach(abonent => {
        status.push(abonent.status);
      });
      return status;
    },
  },
  created () {
    this.isCreated = true;
    this.getClients();
  },
};
</script>

<style lang="scss" scoped>
.list-clients-page {
  padding: 24px;
}

.list-clients-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.list-clients-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.list-clients-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.list-clients-header__btn {
  text-transform: none;
  font-weight: 500;
}

.list-clients-header__switch {
  margin-right: 8px;
}

.list-clients-block {
  border-radius: 12px;
  overflow: hidden;
}

.list-clients-filters {
  padding: 10px 16px 8px;
}

.list-clients-filters__title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #546e7a;
  padding: 0 0 6px 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.list-clients-filters__row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.list-clients-filters__field {
  max-width: 280px;
  width: 100%;
  min-width: 160px;
}

.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}

.v-icon-before {
  margin-right: 8px;
}

.custom-input {
  width: 260px;
  border: none;
  outline: none;
}

@media screen and (max-width: 600px) {
  .list-clients-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .list-clients-header__title {
    font-size: 1.4rem;
  }

  .list-clients-filters__field {
    max-width: none;
  }
}
</style>
